/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as UnitService} from "../../../Services/UnitService";

export class UnitFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			units: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		const {Value} = this.props;

		return Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		UnitService.Get()
			.then((x) => {
				this.setState({units: x.result});
			});
	}

	@autobind
	getUnit() {
		const {Value} = this.props;
		const {units} = this.state || {};

		return units.find((x) => x.unitId == Value);
	}


	@autobind
	_render() {
		let unitLabel = "";
		const unit = this.getUnit();

		if (unit) {
			unitLabel = unit.abbreviation;
		}

		return unitLabel;
	}
}